import { render, staticRenderFns } from "./Antenna.vue?vue&type=template&id=a47bd1a6&scoped=true"
import script from "./Antenna.vue?vue&type=script&lang=ts"
export * from "./Antenna.vue?vue&type=script&lang=ts"
import style0 from "./Antenna.vue?vue&type=style&index=0&id=a47bd1a6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a47bd1a6",
  null
  
)

export default component.exports